module.exports = __webpack_public_path__ + "img/redeem.2ec6c8a1.png";